import { graphql } from 'gql';

export const bimWorkOrderObjectsGql = graphql(`
    query bimWorkOrderObjects(
        $order: [BimWorkOrderObjectDataSortInput!]
        $rootsOnly: Boolean
        $skip: Int
        $take: Int
        $where: BimWorkOrderObjectDataFilterInput
        $workOrderId: Long!
    ) {
        bimWorkOrderObjects(
            rootsOnly: $rootsOnly
            workOrderId: $workOrderId
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                workOrderObjectId
                workOrderId
                fromWorkOrder
                id
                contractId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                parentId
                rootObjectId
                status
                name
                hasGuaranteedVolume
                objectSeasonDistributions {
                    id
                    contractSeason {
                        id
                        year
                    }
                    seasonValue
                }
                rationale
            }
            totalCount
            pageInfo {
                hasNextPage
                hasNextPage
            }
        }
    }
`);

export const bimWorkOrderObjectsForListGql = graphql(`
    query bimWorkOrderObjectsForList(
        $order: [BimWorkOrderObjectDataSortInput!]
        $rootsOnly: Boolean
        $skip: Int
        $take: Int
        $where: BimWorkOrderObjectDataFilterInput
        $workOrderId: Long!
    ) {
        bimWorkOrderObjects(
            rootsOnly: $rootsOnly
            workOrderId: $workOrderId
            order: $order
            skip: $skip
            take: $take
            where: $where
        ) {
            items {
                id
                name
                parentId
                workOrderObjectId
            }
            totalCount
            pageInfo {
                hasNextPage
                hasNextPage
            }
        }
    }
`);

export const bimUploadPriceFilesGql = graphql(`
    mutation bimUploadPriceFiles(
        $chapter: BimChapterEnum!
        $filesContent: [FileInput!]!
        $workOrderId: Long!
        $workOrderObjectId: Long!
    ) {
        bimUploadPriceFiles(
            chapter: $chapter
            filesContent: $filesContent
            workOrderId: $workOrderId
            workOrderObjectId: $workOrderObjectId
        ) {
            data {
                workOrderId
                uploadPriceActs
                isWorkOrderChangeRequired
                itemIds
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimContractSeasonListGql = graphql(`
    query bimContractSeasons($contractId: Long!) {
        bimContractSeasons(contractId: $contractId) {
            data {
                id
                year
            }
        }
    }
`);

export const bimContractSeasonRangeGql = graphql(`
    query bimWorkOrderSeasonsRange($workOrderId: Long!) {
        bimWorkOrderSeasonsRange(workOrderId: $workOrderId) {
            data {
                firstSeason {
                    workOrderId
                    workOrderSeasonId
                    id
                    year
                }
                lastSeason {
                    workOrderId
                    workOrderSeasonId
                    id
                    year
                }
            }
        }
    }
`);

export const bimWorkOrderUpdateSeasonsGql = graphql(`
    mutation bimUpdateWorkOrderSeasons($workOrderId: Long!, $input: BimWorkOrderSeasonsInput!) {
        bimUpdateWorkOrderSeasons(workOrderId: $workOrderId, input: $input) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimWorkOrderObjectSelectionListGql = graphql(`
    query bimWorkOrderObjectSelectionList(
        $order: [BimWorkOrderObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderObjectSelectionDataFilterInput
        $workOrderId: Long!
    ) {
        bimWorkOrderObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                fromWorkOrder
                workOrderObjectId
                workOrderId
                isActKC2Object
                isIncluded
                id
                contractId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                parentId
                rootObjectId
                status
                name
                hasGuaranteedVolume
                objectSeasonDistributions {
                    id
                    contractSeason {
                        id
                        year
                    }
                    seasonValue
                }
                rationale
                order
                hasPrices
                hasActsKC2
            }
            totalCount
        }
    }
`);

export const bimWorkOrderObjectSelectionListIsIncludedGql = graphql(`
    query bimWorkOrderObjectSelectionListIsIncluded(
        $order: [BimWorkOrderObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderObjectSelectionDataFilterInput
        $workOrderId: Long!
    ) {
        bimWorkOrderObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                isIncluded
                id
                constructionType {
                    id
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
            }
            totalCount
        }
    }
`);

export const bimIncludeContractObjectToWorkOrderGql = graphql(`
    mutation bimIncludeContractObjectToWorkOrder($contractObjectId: Long!, $workOrderId: Long!) {
        bimIncludeContractObjectToWorkOrder(contractObjectId: $contractObjectId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimExcludeContractObjectFromWorkOrderGql = graphql(`
    mutation bimExcludeContractObjectFromWorkOrder($contractObjectId: Long!, $workOrderId: Long!) {
        bimExcludeContractObjectFromWorkOrder(contractObjectId: $contractObjectId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimIncludeWorkOrderSeasonGql = graphql(`
    mutation bimIncludeWorkOrderSeason($contractSeasonId: Long!, $workOrderId: Long!) {
        bimIncludeWorkOrderSeason(contractSeasonId: $contractSeasonId, workOrderId: $workOrderId) {
            id
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCompleteStructureFormationGql = graphql(`
    mutation bimCompleteStructureFormation($workOrderId: Long!) {
        bimCompleteStructureFormation(workOrderId: $workOrderId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderObjectGql = graphql(`
    mutation bimCreateWorkOrderObject($input: BimContractObjectCreateInput!, $workOrderId: Long!) {
        bimCreateWorkOrderObject(input: $input, workOrderId: $workOrderId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCreateWorkOrderSubObjectGql = graphql(`
    mutation bimCreateWorkOrderSubObject($input: BimContractSubObjectCreateInput!, $workOrderId: Long!) {
        bimCreateWorkOrderSubObject(input: $input, workOrderId: $workOrderId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveWorkOrderObjectGql = graphql(`
    mutation bimRemoveWorkOrderObject($workOrderId: Long!, $contractObjectId: Long!) {
        bimRemoveWorkOrderObject(workOrderId: $workOrderId, contractObjectId: $contractObjectId) {
            buttonText
            actionRequired
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
            data {
                itemIds
                workOrderId
                isWorkOrderChangeRequired
            }
        }
    }
`);

export const bimWorkOrderPriceMTRDistributionGql = graphql(`
    query bimWorkOrderPriceMTRDistribution($workOrderPriceId: Long!) {
        bimWorkOrderPriceMTRDistribution(workOrderPriceId: $workOrderPriceId) {
            data {
                mp
                op
                mz
                oz
                total
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderPriceMTRDistributionTotalGql = graphql(`
    query bimWorkOrderPriceMTRDistributionTotal(
        $input: BimWorkOrderPriceMTRDistributionInput!
        $workOrderPriceId: Long!
    ) {
        bimWorkOrderPriceMTRDistributionTotal(input: $input, workOrderPriceId: $workOrderPriceId) {
            data {
                total
                deviation
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderPriceMTRDistributionGql = graphql(`
    mutation bimUpdateWorkOrderPriceMTRDistribution(
        $input: BimWorkOrderPriceMTRDistributionInput!
        $workOrderPriceId: Long!
    ) {
        bimUpdateWorkOrderPriceMTRDistribution(input: $input, workOrderPriceId: $workOrderPriceId) {
            id
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderChapterDataGql = graphql(`
    query bimWorkOrderChapterData($workOrderId: Long!, $constructionTypeId: Int, $workOrderRootObjectId: Long) {
        bimWorkOrderChapterData(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            workOrderRootObjectId: $workOrderRootObjectId
        ) {
            data {
                chapter
                pricesCount
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimUpdateWorkOrderSubObjectGql = graphql(`
    mutation bimUpdateWorkOrderSubObject($input: BimContractSubObjectUpdateInput!, $workOrderId: Long!) {
        bimUpdateWorkOrderSubObject(input: $input, workOrderId: $workOrderId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateWorkOrderObjectGql = graphql(`
    mutation bimUpdateWorkOrderObject($input: BimContractObjectUpdateInput!, $workOrderId: Long!) {
        bimUpdateWorkOrderObject(input: $input, workOrderId: $workOrderId) {
            data {
                id
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimIncludeAllObjectsToWorkOrderGql = graphql(`
    mutation bimIncludeAllObjectsToWorkOrder($constructionTypeId: Int, $workOrderId: Long!) {
        bimIncludeAllObjectsToWorkOrder(constructionTypeId: $constructionTypeId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimExcludeAllObjectsFromWorkOrderGql = graphql(`
    mutation bimExcludeAllObjectsFromWorkOrder($constructionTypeId: Int, $workOrderId: Long!) {
        bimExcludeAllObjectsFromWorkOrder(constructionTypeId: $constructionTypeId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimUploadPriceActsGql = graphql(`
    mutation bimUploadPriceActs(
        $chapter: BimChapterEnum!
        $filesContent: [FileInput!]!
        $workOrderId: Long!
        $workOrderObjectId: Long!
        $hasTotalsFromXml: Boolean!
    ) {
        bimUploadPriceActs(
            chapter: $chapter
            filesContent: $filesContent
            workOrderId: $workOrderId
            workOrderObjectId: $workOrderObjectId
            hasTotalsFromXml: $hasTotalsFromXml
        ) {
            actionRequired
            data {
                workOrderId
                uploadPriceActs
                isWorkOrderChangeRequired
                itemIds
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimWorkOrderTotalsRow = graphql(`
    query bimWorkOrderTotals(
        $workOrderId: Long!
        $constructionTypeId: Int
        $chapter: BimChapterEnum
        $workOrderObjectId: Long
        $useInPrices: Boolean!
        $priceLevel: BimPriceLevelEnum
    ) {
        bimWorkOrderTotals(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            chapter: $chapter
            workOrderObjectId: $workOrderObjectId
            useInPrices: $useInPrices
            priceLevel: $priceLevel
        ) {
            items {
                emm
                mp
                mz
                name
                nr
                op
                others
                oz
                ozp
                quantity
                smrTotal
                sortOrder
                sp
                total
                completedValue {
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                remainderValue {
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
                tzr
                zpm
            }
            totalCount
        }
    }
`);

export const bimWorkOrderSeasonsGql = graphql(`
    query bimWorkOrderSeasons(
        $order: [BimWorkOrderSeasonDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimWorkOrderSeasonDataFilterInput
        $workOrderId: Long!
    ) {
        bimWorkOrderSeasons(order: $order, skip: $skip, take: $take, where: $where, workOrderId: $workOrderId) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                workOrderId
                workOrderSeasonId
                id
                year
            }
            totalCount
        }
    }
`);

export const bimExportWorkOrderGql = graphql(`
    query bimExportWorkOrder($workOrderId: Long!) {
        bimExportWorkOrder(workOrderId: $workOrderId) {
            data {
                name
                count
                size
                dataUrl
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimExportWorkOrderPricesGql = graphql(`
    query bimExportWorkOrderPrices($workOrderId: Long!) {
        bimExportWorkOrderPrices(workOrderId: $workOrderId) {
            data {
                name
                count
                size
                dataUrl
            }
            result
            message
            code
            actionRequired
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const bimActKC2OtherGql = graphql(`
    query bimActKC2Other($actKC2OtherId: Long!) {
        bimActKC2Other(actKC2OtherId: $actKC2OtherId) {
            data {
                id
                uniqueId
                contractId
                workOrderId
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                workOrderObject {
                    workOrderObjectId
                    workOrderId
                    fromWorkOrder
                    id
                    contractId
                    constructionType {
                        id
                        code
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    parentId
                    rootObjectId
                    status
                    name
                    hasGuaranteedVolume
                    objectSeasonDistributions {
                        id
                        contractSeason {
                            id
                            year
                        }
                        seasonValue
                    }
                    rationale
                    order
                }
                workOrderSeason {
                    workOrderId
                    workOrderSeasonId
                    id
                    year
                }
                status
                number
                date
                startDate
                finishDate
                contractor
                contractorAddress
                createdAt
                updatedAt
                authoredBy
                updatedBy
                statusFollowers
                hasPlanValues
                isCorrection
                isInactive
                fullNumber
                correctionDate
            }
            hideValidation
            hasValidation
            validation {
                property
                message
                metadata
            }
            result
            message
            code
        }
    }
`);

export const bimCreateActKC2OtherGql = graphql(`
    mutation bimCreateActKC2Other($input: BimActKC2OtherCreateInput!) {
        bimCreateActKC2Other(input: $input) {
            data {
                id
                status
                workOrderId
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimUpdateActKC2OtherGql = graphql(`
    mutation bimUpdateActKC2Other($input: BimActKC2OtherUpdateInput!) {
        bimUpdateActKC2Other(input: $input) {
            data {
                id
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimRemoveActKC2OtherGql = graphql(`
    mutation bimRemoveActKC2Other($actKC2OtherId: Long!) {
        bimRemoveActKC2Other(actKC2OtherId: $actKC2OtherId) {
            id
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimActKC2OtherDefaultsGql = graphql(`
    query bimActKC2OtherDefaults($workOrderId: Long!) {
        bimActKC2OtherDefaults(workOrderId: $workOrderId) {
            data {
                status
                contractor
                contractorAddress
            }
            result
            message
            code
            validation {
                property
                message
            }
        }
    }
`);

export const bimWorkOrderPriceStatesGql = graphql(`
    query bimWorkOrderPriceStates($chapter: BimChapterEnum!, $workOrderObjectId: Long!) {
        bimWorkOrderPriceStates(chapter: $chapter, workOrderObjectId: $workOrderObjectId) {
            data {
                hasExcessCompletedTotalSMR
                hasExcessCompletedOthers
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const bimCalcWorkOrderOtherDistributionGql = graphql(`
    query bimCalcWorkOrderOtherDistribution($input: BimWorkOrderOtherPriceCalcInput!, $workOrderOtherPriceId: Long!) {
        bimCalcWorkOrderOtherDistribution(input: $input, workOrderOtherPriceId: $workOrderOtherPriceId) {
            data {
                workOrderObjectId
                others
                hasErrors
                errors
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);
